/* eslint-disable prettier/prettier */
import React, { FC } from 'react';
import { Text, TransformsStyle, View } from 'react-native';

import ColorWrapper from '@styles/colors';
import { isWeb } from '@helpers';

import svgRegister from './svgRegister';
import { ItemWrapperProps } from '@v2/pages/machines/common/types/props';

// How it works?

// update fill to fill="currentColor" for supporting dynamic colors

export interface SVGIconProps extends Pick<ItemWrapperProps, 'C'> {
  icon: keyof typeof svgRegister;
  width?: number;
  height?: number;
  style?: any;
  color?: string;
  includeScheme?: boolean;
  transform?: TransformsStyle | string;
  preserveAspectRatio?: 'none';
}

const SVGIcon: FC<SVGIconProps> = React.memo(
  (props) => {
    const { icon, C, width, height, style, color, includeScheme, transform, preserveAspectRatio } = props;

    const defaultColor = C('Button/Light/Primary', includeScheme);
    const iconColor = color ? (C(color, includeScheme) ? C(color, includeScheme) : color) : defaultColor;

    const Component = svgRegister[`${icon}`];
    if (!Component) {
      return <Text>No icon</Text>;
    }

    if (isWeb) {
      return (
        <View style={{ width, height }}>
          <Component
            {...(transform && { transform })}
            {...(preserveAspectRatio ? { preserveAspectRatio } : {})}
            {...{ width: '100%', height: '100%', style: { ...style, color: iconColor } }}
          />
        </View>
      );
    }

    return <Component {...(transform && { transform })} {...{ width, height, style: { ...style, color: iconColor } }} />;
  },
  (prev, next) =>
    prev.C.scheme === next.C.scheme &&
    prev.icon === next.icon &&
    prev.color === next.color &&
    prev.width === next.width &&
    prev.height === next.height &&
    prev.transform === next.transform
);

export default ColorWrapper(SVGIcon);
